import { existsSync, readFileSync, statSync } from "node:fs";

const cache = new Map();

/** Shared authored instructions; each script's locale contains only its own additions. */
export function sharedScriptLocaleFile(uiLang) {
  return new URL(`../../../i18n/locales/${/^[a-z]{2,3}$/.test(uiLang) ? uiLang : "en"}/pages/sections/script.json`, import.meta.url);
}

export function sharedScriptLocaleRevision(uiLang) {
  return ["en", uiLang].map(lang => {
    const file = sharedScriptLocaleFile(lang);
    if (!existsSync(file)) return "";
    const stat = statSync(file);
    return `${file}:${stat.mtimeMs}:${stat.size}`;
  }).join("|");
}

export function sharedScriptLocale(uiLang) {
  const file = sharedScriptLocaleFile(uiLang);
  if (!existsSync(file)) return { strings: {}, ui: {} };
  const stat = statSync(file), revision = `${stat.mtimeMs}:${stat.size}`;
  if (cache.get(file.href)?.revision === revision) return cache.get(file.href).copy;
  const copy = JSON.parse(readFileSync(file, "utf8"));
  cache.set(file.href, { revision, copy });
  return copy;
}
